'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = require('../utils/SwitchBase');

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_Element = require('react').babelPluginFlowReactPropTypes_proptype_Element || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var Radio = function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio(props) {
    _classCallCheck(this, Radio);

    var _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));

    _this.removeOutline = function () {
      _this.setState({
        hasOutLine: false
      });
    };

    _this.onBlur = function () {
      _this.setState({
        hasOutLine: true
      });
    };

    _this.onKeyDown = function (evt) {
      if (evt.keyCode === _keyCode2.default.TAB) {
        _this.setState({
          hasOutLine: true
        });
      }
    };

    _this.state = {
      hasOutLine: true
    };
    return _this;
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _ClassNames;

      var _props = this.props,
          style = _props.style,
          className = _props.className,
          children = _props.children,
          disabled = _props.disabled,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'children', 'disabled']);

      var classes = (0, _classnames2.default)('a-radio-wrapper', className, (_ClassNames = {}, _defineProperty(_ClassNames, 'a-radio-icon-wrapper', this.props.uncheckedIcon), _defineProperty(_ClassNames, 'a-radio-wrapper-disabled', disabled), _defineProperty(_ClassNames, 'a-radio-wrapper-checked', this.props.checked), _defineProperty(_ClassNames, 'without-outline', !this.state.hasOutLine), _ClassNames));
      return _react2.default.createElement(
        'label',
        {
          style: style,
          className: classes,
          onMouseDown: this.removeOutline,
          onKeyDown: this.onKeyDown,
          onBlur: this.onBlur
        },
        _react2.default.createElement(_SwitchBase2.default, Object.assign({
          type: 'radio',
          disabled: disabled
        }, otherProps)),
        children !== undefined && _react2.default.createElement(
          'span',
          { className: 'a-radio-text', onClick: this.removeOutline },
          children
        )
      );
    }
  }]);

  return Radio;
}(_react2.default.Component);

exports.default = Radio;